import React from 'react'

import SidebarPropertiesMobile from './sidebar.component'
import SidebarPropertiesMobileSus from './sidebarSus.component'


interface Props {
  isProperties: boolean,
  colorsData: boolean,
  inmueblesData: any,
  handlePropertiesFilter: any,
  avalabilityAttributesToShow: any,
  handleFilterAvailability: any,
  isDetailed: any,
  handleCloseDetailedSpin: any,
  hasDispo: boolean
}

interface State {
  inmueblesData: any,
  attributesFilteredObject: any,

}

interface PropertiesContainerMobile {
  propertiesRef: any
}

class PropertiesContainerMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      inmueblesData: {},
      attributesFilteredObject: {},

    }

    this.propertiesRef = React.createRef()
  }

  componentDidMount = async() => {
    this.createAttributesFilterStructure()
  }



  createAttributesFilterStructure = () => {
    var attributesFilterObject: any = {}

    this.props.inmueblesData.properties.attributes.map((attribute: any, index: number) => 
      attributesFilterObject[attribute.id] = []
    )

    this.setState({
      attributesFilteredObject: attributesFilterObject
    })
  }

  handleUpdateFilterObject = (payload: any) => {
    this.setState({
      attributesFilteredObject: payload
    }, () => {
      this.props.handlePropertiesFilter(this.state.attributesFilteredObject)
    })
  }

  handleHideMenus = () => {
    this.propertiesRef.current.handleHideMenus()
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.isProperties ? 'properties-container-mobile fade-in':'properties-container-mobile fade-out'}>
          
          {
            this.props.inmueblesData.properties && this.props.inmueblesData.type_filter === 1 ?
            <SidebarPropertiesMobile
              ref = {this.propertiesRef}
              colorsData={this.props.colorsData}
              inmueblesData={this.props.inmueblesData}
              attributesFilterObject={this.state.attributesFilteredObject}
              handleUpdateFilterObject={this.handleUpdateFilterObject}
              avalabilityAttributesToShow = {this.props.avalabilityAttributesToShow}
              handleFilterAvailability = {this.props.handleFilterAvailability}
              isDetailed={this.props.isDetailed}
              handleCloseDetailedSpin = {this.props.handleCloseDetailedSpin}
              hasDispo = {this.props.hasDispo}
            />:null
          }
          {
            this.props.inmueblesData.properties && this.props.inmueblesData.type_filter === 0 ?
            <SidebarPropertiesMobileSus
              ref = {this.propertiesRef}
              colorsData={this.props.colorsData}
              inmueblesData={this.props.inmueblesData}
              attributesFilterObject={this.state.attributesFilteredObject}
              handleUpdateFilterObject={this.handleUpdateFilterObject}
              avalabilityAttributesToShow = {this.props.avalabilityAttributesToShow}
              handleFilterAvailability = {this.props.handleFilterAvailability}
              isDetailed={this.props.isDetailed}
              handleCloseDetailedSpin = {this.props.handleCloseDetailedSpin}
              hasDispo = {this.props.hasDispo}
            />:null
          }
        </div>
      )
  }
}

export default PropertiesContainerMobile